// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".CatalogFiltersWidgetImages__button{opacity:.7}.CatalogFiltersWidgetImages__button--selected{opacity:1}.CatalogFiltersWidgetImages__button--disabled{cursor:not-allowed;opacity:.2}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
